<section class="container-fluid step-container space">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-3 separator">
        <a routerLink="/aboutme/work/conception" class="step-item-container ">
          <div class="step-item-wrapper konzeption">
            <label>Konzeption</label>
          </div>
        </a>
      </div>
      <div class="col-xs-12 col-sm-3 separator">
        <a routerLink="/aboutme/work/uxdesign" class="step-item-container " data-aos="fade-up">
          <div class="step-item-wrapper design">
            <label>UX-Design</label>
          </div>
        </a>
      </div>
      <div class="col-xs-12 col-sm-3 separator">
        <a routerLink="/aboutme/work/programming" class="step-item-container ">
          <div class="step-item-wrapper programming">
            <label>Entwicklung</label>
          </div>
        </a>
      </div>
      <div class="col-xs-12 col-sm-3 separator">
        <a routerLink="/aboutme/work/quality" class="step-item-container ">
          <div class="step-item-wrapper konzeption">
            <label>Qualität</label>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>
